import NextImage, { ImageProps } from 'next/image';
import { useState } from 'react';

type ExtendedImageProps = {
  fallbackSrc?: string;
  src: ImageProps['src'] | undefined;
} & Omit<ImageProps, 'src' | 'onLoadingComplete' | 'onError'>;

type ImageLoadStatus = 'pending' | 'success' | 'error';

export function Image({
  fallbackSrc = '/images/product_placeholder.png',
  ...props
}: ExtendedImageProps) {
  const [status, setStatus] = useState<ImageLoadStatus>(() =>
    props.src ? 'pending' : 'error'
  );
  const isError = status === 'error';

  return (
    <NextImage
      quality={90}
      placeholder="empty"
      {...props}
      data-fallback-src={fallbackSrc}
      style={props.style}
      src={isError ? fallbackSrc : props.src || fallbackSrc}
      onLoadingComplete={() => {
        if (!isError) {
          setStatus('success');
        }
      }}
      onError={() => setStatus('error')}
    />
  );
}
